import * as React from 'react'

import AuthProvider from './auth-provider'
import MuiThemeProvider from './mui-theme-provider'
import SnackbarNotificationProvider from './snackbar-provider'

const AllProviders = ({ children }: { children: React.ReactNode[] | React.ReactNode }) => (
  <MuiThemeProvider>
    <SnackbarNotificationProvider>
      <AuthProvider>{children}</AuthProvider>
    </SnackbarNotificationProvider>
  </MuiThemeProvider>
)

export default AllProviders
